import { SCENARIO_VARIATION_LIST_DATA } from "../../../constants/closeLoop/scenarioGroup/expandableScenarioComponentConstants";

export const scenarioVariationListData = (scenarioVariationData) => (dispatch) => {
    dispatch({
        type: SCENARIO_VARIATION_LIST_DATA,
        scenarioVariationData: scenarioVariationData.data,
        pages: scenarioVariationData.pages,
        currentPage: scenarioVariationData.current_page,
    });
};
